import { DescriptionInput } from '@/engagements/base/admin/DescriptionInput';
import {
  Section,
  SectionContent,
  SectionHeading,
  SettingRowDescription,
  SettingRowHeading,
  SettingRowInput,
  SettingsRow,
  SettingsTable,
} from '@/components/Section';
import { QRCodeCtaInput } from '@/engagements/base/admin/QRCodeCtaInput';
import { TitleInput } from '@/engagements/base/admin/TitleInput';
import { TicketFlipDirectionInput } from './TicketFlipDirectionInput';
import { ClaimYourPrizeInput } from './ClaimYourPrizeInput';

export function RaffleEditorView() {
  return (
    <Section>
      <SectionHeading>Settings</SectionHeading>
      <SectionContent>
        <SettingsTable>
          <SettingsRow>
            <SettingRowHeading>Title</SettingRowHeading>
            <SettingRowDescription>
              Shows as a pulsing title above the QR code. Keep it short.
            </SettingRowDescription>
            <SettingRowInput>
              <TitleInput />
            </SettingRowInput>
          </SettingsRow>

          <SettingsRow>
            <SettingRowHeading>Instructions</SettingRowHeading>
            <SettingRowDescription>
              Shown as instructions to fans on mobile.
            </SettingRowDescription>
            <SettingRowInput>
              <DescriptionInput />
            </SettingRowInput>
          </SettingsRow>

          <SettingsRow>
            <SettingRowHeading>QR code label</SettingRowHeading>
            <SettingRowDescription>
              Displayed above the QR code. Keep it short.
            </SettingRowDescription>
            <SettingRowInput>
              <QRCodeCtaInput />
            </SettingRowInput>
          </SettingsRow>

          <SettingsRow>
            <SettingRowHeading>Claim your prize</SettingRowHeading>
            <SettingRowDescription>
              Shown on Stage and Fan when drawing completes. Wrap accent words
              in *asterisks*.
            </SettingRowDescription>
            <SettingRowInput>
              <ClaimYourPrizeInput />
            </SettingRowInput>
          </SettingsRow>

          <SettingsRow>
            <SettingRowHeading>Ticket flip</SettingRowHeading>
            <SettingRowDescription>
              Animation for new Stage tickets. Tickets already on Stage keep
              their current face.
            </SettingRowDescription>
            <SettingRowInput>
              <TicketFlipDirectionInput />
            </SettingRowInput>
          </SettingsRow>
        </SettingsTable>
      </SectionContent>
      {/* <pre>{JSON.stringify(engagement.config, null, 2)}</pre> */}
    </Section>
  );
}
